/**
 * OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPage
 *
 * Page component for OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPage
 * Path: /sl/docs/tutorials/beginner/complete-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView as __OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView';
import { OrbDocTutorialsBeginnerCompleteOrbitalSLDocAnalyticsView as __OrbDocTutorialsBeginnerCompleteOrbitalSLDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPage(_props: OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Zgradi celoten orbital","description":"Zgradi postopek odobritve stroškov od enega stanja do štirih, s pogojem, ki uveljavlja pravilo porabe.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/complete-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/complete-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/complete-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerCompleteOrbitalSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerCompleteOrbitalSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalSLOrbDocTutorialsBeginnerCompleteOrbitalSLPage;
